/**
 * This redirection allows us to have shorter URLs output by the SDK
 * and to change where URLs go without changing the SDK.
 */
import {WFDataModelAutoProvider} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/context';
import React from 'react';
import {useParams} from 'react-router';
import {Route, Switch, useRouteMatch} from 'react-router-dom';

import NoMatch from '../../components/NoMatch';
import {RedirectCall} from './RedirectCall';

type RedirectPageParams = {
  entityName: string;
  projectName: string;
};

const RedirectPage = () => {
  const {entityName, projectName} = useParams<RedirectPageParams>();
  const {path} = useRouteMatch();

  // Warning: Removing any routes could break links the SDKs print.
  return (
    <Switch>
      <Route path={`${path}/call/:callId`}>
        <WFDataModelAutoProvider>
          <RedirectCall />
        </WFDataModelAutoProvider>
      </Route>
      <Route>
        <NoMatch />
      </Route>
    </Switch>
  );
};

export default RedirectPage;
